"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var _ = require("underscore");
var index_1 = require("../../../index");
var formCore_1 = require("../formCore");
var validationWrapper_1 = require("../validationWrapper");
var CodeInput = /** @class */ (function (_super) {
    tslib_1.__extends(CodeInput, _super);
    function CodeInput(props) {
        var _this = _super.call(this, props) || this;
        _this.uniq = Math.random();
        _this.state = { focusIndex: null };
        return _this;
    }
    CodeInput.prototype.focusNext = function (e) {
        var movingBack = false;
        var current = e.target;
        var el;
        var currentVal = current.value.trim();
        var lpb = this.props.lengthPerBox[this.state.focusIndex];
        var retFromStore = false;
        currentVal = currentVal.slice(0, lpb);
        if (e.keyCode === 8) {
            movingBack = true;
            if (currentVal.length === 0) {
                el = current.previousSibling;
            }
            else {
                el = current;
            }
        }
        else {
            el = current.nextSibling;
            if (this.storedKey && el && !el.value) {
                el.value = this.storedKey;
                this.storedKey = null;
                retFromStore = true;
            }
        }
        if (currentVal.length < lpb && !movingBack) {
            return;
        }
        if (el) {
            el.focus();
            if (el && el.value && !movingBack && !retFromStore) {
                el.value = "";
            }
        }
        this.buildValue();
    };
    CodeInput.prototype.buildValue = function () {
        var value = "";
        var current = document.getElementById("input_" + this.uniq + "_0");
        this.props.lengthPerBox.forEach(function (lpb, i) {
            value += current.value;
            current = current.nextSibling;
        });
        if (this.props.numeric) {
            value = parseInt(value, 10);
        }
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    };
    CodeInput.prototype.handlePaste = function (e) {
        var length = _.reduce(this.props.lengthPerBox, function (memo, num) { return memo + num; }, 0);
        var pasted = e.clipboardData.getData("text/plain").replace(/\s/g, "");
        pasted = pasted.substr(0, length);
        if (this.props.numeric) {
            var parsed = parseInt(pasted, 10);
            if (isNaN(parsed)) {
                e.preventDefault();
                return false;
            }
        }
        var current = e.target;
        var splitArray = [];
        var currentIndex = 0;
        this.props.lengthPerBox.forEach(function (lpb, i) {
            var chunk = pasted.substr(currentIndex, lpb);
            currentIndex += lpb;
            splitArray.push(chunk);
            current.value = chunk;
            current = current.nextSibling;
        });
        this.buildValue();
    };
    CodeInput.prototype.handleFocus = function (index, input) {
        this.setState({ focusIndex: index });
        this.storedKey = null;
    };
    CodeInput.prototype.keyDown = function (e) {
        // console.log(e.key)
        var lpb = this.props.lengthPerBox[this.state.focusIndex];
        var selectionLength = window.getSelection().toString().length;
        if (selectionLength === lpb) {
            return;
        }
        if (e.currentTarget.value.length === lpb) {
            if (e.keyCode >= 48 && e.keyCode <= 57) {
                this.storedKey = e.key;
            }
            if (e.keyCode >= 65 && e.keyCode <= 90) {
                this.storedKey = e.key;
            }
        }
    };
    CodeInput.prototype.handleClick = function (e) {
        if (e.currentTarget.value) {
            e.currentTarget.select();
        }
    };
    CodeInput.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.value) {
            var currentIndex_1 = 0;
            this.props.lengthPerBox.forEach(function (lpb, i) {
                var input = document.getElementById("input_" + _this.uniq + "_" + i);
                var chunk = _this.props.value.substr(currentIndex_1, lpb);
                currentIndex_1 += lpb;
                input.value = chunk;
            });
        }
    };
    CodeInput.prototype.calcTabIndex = function (tabIndex, fieldIndex) {
        if (tabIndex === undefined || tabIndex === -1) {
            return tabIndex;
        }
        return tabIndex + fieldIndex;
    };
    CodeInput.prototype.render = function () {
        var _this = this;
        var validationMessage = formCore_1.DataValidationMessage.get(this.props);
        var _a = this.props, onChange = _a.onChange, validationMode = _a.validationMode, lengthPerBox = _a.lengthPerBox, numeric = _a.numeric, type = _a.type, className = _a.className, tabIndex = _a.tabIndex, attrs = tslib_1.__rest(_a, ["onChange", "validationMode", "lengthPerBox", "numeric", "type", "className", "tabIndex"]);
        var classes = index_1.ClassHelpers.classNames("armstrong-input", "code-input", this.props.className, {
            "show-validation": validationMode !== "none" && validationMessage,
        });
        return (React.createElement("div", { className: classes },
            React.createElement("div", null, this.props.lengthPerBox.map(function (lpb, i) { return (React.createElement("input", { id: "input_" + _this.uniq + "_" + i, className: "code-input-field", tabIndex: _this.calcTabIndex(_this.props.tabIndex, i), key: "cb_" + _this.uniq + "_" + i, type: _this.props.type || "text", placeholder: _this.props.placeholder, maxLength: lpb, readOnly: _this.props.readonly, onClick: function (e) { return _this.handleClick(e); }, onFocus: function (e) { return _this.handleFocus(i, e.target); }, onKeyUp: function (e) { return _this.focusNext(e); }, onKeyDown: function (e) { return _this.keyDown(e); }, onPaste: function (e) { return _this.handlePaste(e); }, onChange: function (e) { return _this.buildValue(); } })); })),
            React.createElement(validationWrapper_1.ValidationLabel, { message: validationMessage, mode: validationMode })));
    };
    CodeInput.defaultProps = {
        lengthPerBox: [2, 2, 2],
        validationMode: "none",
    };
    return CodeInput;
}(React.Component));
exports.CodeInput = CodeInput;
